<a class="box" href="https://api.whatsapp.com/send?phone=5584933005548&text=Ol%C3%A1%2C%20bem-vindo(a)%20%C3%A0%20Para%C3%ADso%20Fotovoltaico!%20Fale%20comigo%20por%20aqui..." target="_blank">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      d="M131.453,115.753a9.782,9.782,0,0,0-9.818,9.743,9.637,9.637,0,0,0,1.41,5.03l-1.774,5.227,5.436-1.727a9.766,9.766,0,1,0,4.745-18.273Zm4.882,13.442a2.53,2.53,0,0,1-1.737,1.119c-.46.026-.473.357-2.982-.734a10.243,10.243,0,0,1-4.14-3.913,4.816,4.816,0,0,1-.926-2.61,2.786,2.786,0,0,1,.956-2.041.969.969,0,0,1,.68-.287c.2,0,.325,0,.471,0s.366-.03.556.475.644,1.748.7,1.874a.456.456,0,0,1,0,.436,1.734,1.734,0,0,1-.267.406c-.131.139-.274.315-.392.421s-.267.248-.13.5a7.493,7.493,0,0,0,1.331,1.774,6.8,6.8,0,0,0,1.968,1.309c.246.135.394.12.546-.041s.653-.7.83-.946.342-.195.569-.1,1.436.74,1.682.873.411.2.469.308a2.047,2.047,0,0,1-.19,1.177Z"
      transform="translate(-121.271 -115.753)"
      fill="#2acc16"
    />
  </svg>
  <span class="label">(84) 93300.5548</span>
</a>

<div class="icon-section">
  <a class="icon" href="https://bit.ly/37WsIf4" target="_blank">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.864 21.5">
      <g transform="translate(-2.25 -0.25)">
        <path
          d="M19.364,9.182C19.364,15.545,11.182,21,11.182,21S3,15.545,3,9.182a8.182,8.182,0,0,1,16.364,0Z"
          fill="none"
          stroke="#2acc16"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <circle
          cx="2.727"
          cy="2.727"
          r="2.727"
          transform="translate(8.455 6.455)"
          fill="none"
          stroke="#2acc16"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </svg>
    <span class="label">TIBAU DO SUL | RN</span>
  </a>
  <a
    class="icon"
    href="https://www.instagram.com/paraisofotovoltaico/"
    target="_blank"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <g transform="translate(-64 -64)">
        <path
          d="M78.167,65.667a4.179,4.179,0,0,1,4.167,4.167v8.333a4.179,4.179,0,0,1-4.167,4.167H69.833a4.179,4.179,0,0,1-4.167-4.167V69.833a4.179,4.179,0,0,1,4.167-4.167h8.333m0-1.667H69.833A5.85,5.85,0,0,0,64,69.833v8.333A5.85,5.85,0,0,0,69.833,84h8.333A5.85,5.85,0,0,0,84,78.167V69.833A5.85,5.85,0,0,0,78.167,64Z"
          fill="#2acc16"
        />
        <path
          d="M170.417,130.5a1.25,1.25,0,1,1,1.25-1.25A1.247,1.247,0,0,1,170.417,130.5Zm-5.417.833a3.333,3.333,0,1,1-3.333,3.333A3.336,3.336,0,0,1,165,131.333m0-1.667a5,5,0,1,0,5,5A5,5,0,0,0,165,129.667Z"
          transform="translate(-91 -60.667)"
          fill="#2acc16"
        />
      </g>
    </svg>
    <span class="label">SIGA-NOS</span>
  </a>
</div>
